import Sidebar from 'MentalHealth/components/Sidebar/Sidebar';
import TopBar from 'MentalHealth/components/TopBar';
import React from 'react';
import { useLocation } from 'react-router-dom';
import FloatingVideo from 'MentalHealth/components/Floating/FloatingVideo';
import Draggable from 'react-draggable';
import FloatingAudioCall from 'MentalHealth/components/Floating/FloatingAudioCall';
import { useSelector } from 'react-redux'
const appId = process.env.REACT_APP_AGORA_APP_ID

const CounselorLayout = ({ role, children }) => {
  const { manageCallData } = useSelector((state) => state.callData)
  const { engageCall, callType } = manageCallData

  const location = useLocation();

  return (
    <div className="container-fluid p-0 d-flex" style={{ minHeight: '100vh' }}>
      <Sidebar {...{ role }} />
      <div
        className="content flex-grow-1 p-2"
        style={{ overflowY: 'auto', marginLeft: '80px' }}
      >
        <TopBar />
        {children}

        {/* Floating Video */}
        {engageCall &&
          callType === 'videoCall' &&
          location.pathname !== '/active-chats' && (
            <Draggable bounds="parent">
              <div
                style={{
                  position: 'fixed',
                  top: 300,
                  right: 60,
                  zIndex: 12,
                }}
              >
                <FloatingVideo appId={appId}/>
              </div>
            </Draggable>
        )}

        {/* Floating Audio Call */}
        {engageCall &&
          callType === 'audioCall' &&
          location.pathname !== '/active-chats' && (
            <Draggable bounds="parent">
              <div
                style={{
                  position: 'fixed',
                  top: 150,
                  right: 60,
                  zIndex: 12,
                }}
              >
                <FloatingAudioCall appId={appId}/>
              </div>
            </Draggable>
          )}
      </div>
    </div>
  );
};

export default CounselorLayout;
